var map = {
	"./_details-disclosure.js": "./assets/js/HTMLElement/_details-disclosure.js",
	"./_dialog.js": "./assets/js/HTMLElement/_dialog.js",
	"./_slider.js": "./assets/js/HTMLElement/_slider.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/js/HTMLElement sync recursive \\.js$";